(() => {
  const ROOT_SELECTOR = '[data-fk-impact-stories]';

  function initialiseStories(root) {
    if (!root || root.dataset.impactStoriesInitialised === 'true') return;

    const cards = Array.from(root.querySelectorAll('[data-impact-story]'));
    const pagination = root.querySelector('[data-impact-pagination]');
    const pages = root.querySelector('[data-impact-pages]');
    const previousButton = root.querySelector('[data-impact-previous]');
    const nextButton = root.querySelector('[data-impact-next]');
    const status = root.querySelector('[data-impact-status]');
    const pageSize = Math.max(1, Number(root.dataset.pageSize) || 4);

    if (!cards.length || !pagination || !pages || !previousButton || !nextButton) return;

    root.dataset.impactStoriesInitialised = 'true';
    const pageCount = Math.ceil(cards.length / pageSize);
    let currentPage = 0;

    function showPage(pageIndex) {
      currentPage = Math.min(pageCount - 1, Math.max(0, pageIndex));
      const firstVisibleIndex = currentPage * pageSize;
      const lastVisibleIndex = Math.min(firstVisibleIndex + pageSize, cards.length);

      cards.forEach((card, index) => {
        card.hidden = index < firstVisibleIndex || index >= lastVisibleIndex;
      });

      pages.querySelectorAll('[data-impact-page]').forEach((button, index) => {
        if (index === currentPage) {
          button.setAttribute('aria-current', 'page');
        } else {
          button.removeAttribute('aria-current');
        }
      });

      previousButton.disabled = currentPage === 0;
      nextButton.disabled = currentPage === pageCount - 1;

      if (status) {
        status.textContent = `Showing stories ${firstVisibleIndex + 1} to ${lastVisibleIndex} of ${cards.length}`;
      }
    }

    if (pageCount <= 1) {
      pagination.hidden = true;
      if (status) status.textContent = `${cards.length} impact stories shown`;
      return;
    }

    const pageLabel = root.dataset.pageLabel || 'Go to impact stories page';
    for (let index = 0; index < pageCount; index += 1) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'fk-impact-stories__page';
      button.dataset.impactPage = String(index);
      button.textContent = String(index + 1);
      button.setAttribute('aria-label', `${pageLabel} ${index + 1}`);
      button.addEventListener('click', () => showPage(index));
      pages.appendChild(button);
    }

    previousButton.addEventListener('click', () => showPage(currentPage - 1));
    nextButton.addEventListener('click', () => showPage(currentPage + 1));
    pagination.hidden = false;
    showPage(0);

    root.addEventListener('shopify:block:select', (event) => {
      const selectedCard = event.target.closest('[data-impact-story]');
      const selectedIndex = cards.indexOf(selectedCard);
      if (selectedIndex >= 0) showPage(Math.floor(selectedIndex / pageSize));
    });
  }

  function initialiseAll(scope) {
    if (scope.matches && scope.matches(ROOT_SELECTOR)) initialiseStories(scope);
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initialiseStories);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(document));
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
